import React from 'react';
import { ArrowRight } from 'lucide-react';
import { mockData } from '../data/mock';

const Hero = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section style={styles.hero}>
      <div className="container">
        <div style={styles.content}>
          <div style={styles.textContent} className="fade-in-up">
            <h1 className="display-large" style={styles.title}>
              {mockData.hero.title}
            </h1>
            <p style={styles.subtitle} className="display-medium fade-in-up delay-200">
              {mockData.hero.subtitle}
            </p>
            <p className="body-large fade-in-up delay-400" style={styles.description}>
              {mockData.hero.description}
            </p>
            <button 
              onClick={scrollToBooking}
              className="btn-primary fade-in-up delay-600" 
              style={styles.ctaButton}
            >
              {mockData.hero.cta}
              <ArrowRight style={styles.icon} size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  hero: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    paddingTop: '100px',
    paddingBottom: '80px',
    background: 'var(--bg-page)',
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContent: {
    maxWidth: '900px',
    textAlign: 'center',
  },
  title: {
    marginBottom: '16px',
  },
  subtitle: {
    color: 'var(--brand-primary)',
    marginBottom: '24px',
  },
  description: {
    marginBottom: '32px',
    maxWidth: '700px',
    margin: '0 auto 32px',
  },
  ctaButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
  },
  icon: {
    transition: 'transform 0.2s ease',
  },
};

// Add hover effect for icon
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  .btn-primary:hover svg {
    transform: translateX(4px);
  }
`;
document.head.appendChild(styleSheet);

export default Hero;